// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2StFJ","messages":"Chat_messages__2wsP1","dateDivider":"Chat_dateDivider__3AFu9"};